import { network } from 'services/network';

export const updateGateTemplate = (params) => {
    return network.post('api/bo/phaseperformance/updateGateTemplate', params).then((response) => {
        return response.data;
    });
};
